import { ParcelSchema } from "@redotech/redo-model/outbound-labels/parcel";
import * as z from "zod";
import { null as zNull } from "zod";
export const getParcels = {
  name: "getParcels" as const,
  input: zNull(),
  output: z.object({ parcels: z.array(ParcelSchema) }),
};
